import { useState } from 'react';
import { IconCirclePlus } from '@rossum/ui/icons/tabler';
import {
  Autocomplete,
  Chip,
  IconButton,
  SvgIcon,
  TextField,
} from '@rossum/ui/material';
import { useOperators } from '../hooks/useOperators';
import { doUnsavedValuesExist } from './doUnsavedValuesExist';
import { FilterActionsWrapper } from './FilterActionsWrapper';
import { SimpleFilterComponentProps } from './FilterComponentProps';

export const FilterMultiString = ({
  filterItem,
  onClose,
  onBackClick,
  applyFilter,
  convertToAdvancedFilter,
  onOperatorChange,
}: SimpleFilterComponentProps) => {
  const { filterContext } = filterItem;

  const existingValues = Array.isArray(filterContext.value)
    ? filterContext.value
    : typeof filterContext.value === 'string' && filterContext.value
      ? [filterContext.value]
      : [];

  const [selectedOptions, setSelectedOptions] =
    useState<string[]>(existingValues);

  const [value, setValue] = useState<string>('');

  const { node: Operators, operator } = useOperators({
    filterItem,
    onChange: onOperatorChange,
    value: value.length ? value : undefined,
  });

  const handleOnClickOnMore = convertToAdvancedFilter
    ? () =>
        convertToAdvancedFilter(
          operator,
          doUnsavedValuesExist(selectedOptions, filterContext.value)
            ? selectedOptions
            : undefined
        )
    : undefined;

  const valueIsAlreadySelected = selectedOptions.includes(value);

  return (
    <FilterActionsWrapper
      onBackClick={onBackClick}
      onCancel={onClose}
      onSubmit={() =>
        applyFilter({
          operator,
          value: selectedOptions,
        })
      }
      isSubmitDisabled={!selectedOptions.length}
      onClickOnMore={handleOnClickOnMore}
      columnField={filterItem.column.field}
    >
      <Operators />
      <Autocomplete
        clearIcon={false}
        fullWidth
        multiple
        freeSolo
        value={selectedOptions}
        onChange={(_, values) => setSelectedOptions(values)}
        inputValue={value}
        renderTags={(values, getTagProps) =>
          values.map((option: string, index: number) => (
            <Chip {...getTagProps({ index })} key={option} label={option} />
          ))
        }
        renderInput={params => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: value.length ? (
                <IconButton
                  size="small"
                  disabled={valueIsAlreadySelected}
                  onClick={() => {
                    setSelectedOptions(prev => [...prev, value]);
                    setValue('');
                  }}
                  sx={{ ml: 'auto' }}
                >
                  <SvgIcon fontSize="medium" color="primary">
                    <IconCirclePlus />
                  </SvgIcon>
                </IconButton>
              ) : null,
            }}
            sx={{ maxHeight: 400, overflow: 'auto' }}
          />
        )}
        onInputChange={(_, newValue) => setValue(newValue)}
        options={[]}
      />
    </FilterActionsWrapper>
  );
};
